import { Stage } from '@recruitee/http/types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } = createEntityCollectionStore<Stage>()(
  'offer-stages',
  {
    customActions: adapter => ({
      references: (state, payload: { data: Stage[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

const StageActions = <Pick<typeof actions, 'references'>>actions;

export {
  StageActions,
  reducer as StageReducer,
  namespace as StageNamespace,
  selectors as StageSelectors,
};
